import { Suspense, useState, useEffect } from 'react'
import Header from './furniture/Header'
import Breadcrumbs from './furniture/Breadcrumbs'
import Footer from './furniture/Footer'
import Loader from './helpers/Loader'
import Alert from './furniture/Alert'
import Skip from './furniture/Skip'

import Accordion from './sections/Accordion'
import BasicContent from './sections/BasicContent'
import BasicContentWithColumns from './sections/BasicContentWithColumns'
import CalloutCard from './sections/CalloutCard'
import CardListCurated from './sections/CardListCurated'
import CardListDynamic from './sections/CardListDynamic'
import ContentFiftybyFifty from './sections/ContentFiftybyFifty'
import HeroBanner from './sections/HeroBanner'
import InformationBanner from './sections/InformationBanner'
import RatesCalculator from './sections/RatesCalculator'
import RatesCalloutCard from './sections/RatesCalloutCard'
import RatesCardList from './sections/RatesCardList'
import SearchResult from './sections/SearchResult'
import SubPageBanner from './sections/SubPageBanner'
import ThirdParty from './sections/ThirdParty'
import { showExternalLinkIcons } from '../helpers/style'
import RatesCalloutBanner from './sections/RatesCalloutBanner'
import ProductFiftyFiftyContent from './sections/ProductFiftyFiftyContent'
import TagListing from './sections/TagListing'

function Page(props) {
  const [ComponentsList, setComponentsList] = useState([])
  const [menuActive, setMenuActive] = useState(false)
  const [searchActive, setSearchActive] = useState(false)
  const [ctasActive, setCtasActive] = useState(false)

  const components = {
    accordion: Accordion,
    basicContent: BasicContent,
    basicContentWithColumns: BasicContentWithColumns,
    calloutCard: CalloutCard,
    cardListCurated: CardListCurated,
    cardListDynamic: CardListDynamic,
    contentFiftybyFifty: ContentFiftybyFifty,
    heroBanner: HeroBanner,
    informationBanner: InformationBanner,
    ratesCalculator: RatesCalculator,
    ratesCalloutCard: RatesCalloutCard,
    ratesCardList: RatesCardList,
    searchResult: SearchResult,
    subPageBanner: SubPageBanner,
    thirdParty: ThirdParty,
    ratesCalloutBanner: RatesCalloutBanner,
    productFiftyFiftyContent: ProductFiftyFiftyContent,
    tagListing: TagListing,
  }

  const noDataExcludeList = [
    // a list of items that don't require data, and will not trigger the warning and be ignored if the data object does not exist.
    // there should not be too many of these.
    'thirdParty',
  ]

  useEffect(() => {
    showExternalLinkIcons()
  }, [])

  useEffect(() => {
    if (props.content?.length) {
      setComponentsList(() => {
        // This only loads once, on page load, so we don't need to worry about the content of prevState
        const newState = []
        if (!props.content.some(comp => comp.componentData.key == 'thirdParty')) {
          props.content.push({
            componentName: 'thirdParty',
            componentData: {key: 'thirdParty'},
          })
        }

        props.content.forEach((comp) => {
          const compName = comp.componentName
          const capComp = `${compName.charAt(0).toUpperCase()}${compName.slice(1)}`
          if (comp.componentData) {
            newState.push({
              name: comp.componentName,
              data: comp.componentData,
            })
          } else {
            console.warn(`No data sent for component ${comp.componentName}`)
          }
        })
        return [...newState]
      })
    }
  }, [props.content])

  return (
    <>
      <Skip />
      <Header
        deskLogo={props.nav?.siteLogo ?? ''}
        mobLogo={props.nav?.siteLogoMobile ?? ''}
        ctas={props.nav?.utilityLinks}
        contactUsCta={props.nav?.contactUsCta}
        menuActive={menuActive}
        setMenuActive={setMenuActive}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
        ctasActive={ctasActive}
        setCtasActive={setCtasActive}
        nav={props.nav?.items}
        res={props.res}
      >
        {props.res.globalEnablePageAlert &&
          (props.res.globalPageAlertTitle || props.res.globalPageAlertDescription) && (
            <Alert
              title={props.res.globalPageAlertTitle}
              type={props.res.globalPageAlertType}
              description={props.res.globalPageAlertDescription}
            />
          )}
        {props.res.enablePageAlert && (props.res.pageAlertTitle || props.res.pageAlertDescription) && (
          <Alert
            title={props.res.pageAlertTitle}
            type={props.res.pageAlertType}
            description={props.res.pageAlertDescription}
          />
        )}
      </Header>
      <main id="main">
        <Breadcrumbs items={props.breadcrumbs} />
        <Suspense key={'pageSuspender'} fallback={<Loader />}>
          {ComponentsList &&
            ComponentsList.length > 0 &&
            ComponentsList.map((comp, idx) => {
              const TagName = components[comp.name]
              if (!TagName) {
                console.warn(`Component type ${comp.name} was not found. Ignoring...`)
                return <></>
              }
              if (!Object.keys(comp.data).length && !noDataExcludeList.includes(comp.name)) {
                console.warn(`No data for component type ${comp.name} was found. Ignoring...`)
                return <></>
              }
              return <TagName key={comp.data.key} {...comp.data} idx={idx} />
            })}
          <></>
        </Suspense>
      </main>
      {!props.res.disablePrimaryFooter && (
        <Footer
          {...props.footer}
          disableSticky={props.res.disableUtilityFooter}
          stickyNavPrimary={props.nav?.primaryLink}
          stickyNavSecondary={props.nav?.mobileStickyNavigationItems}
        />
      )}
    </>
  )
}

export default Page
